module.exports = __webpack_public_path__ + "img/logo.e19e042c.png";